import { DashCircle } from "react-bootstrap-icons";
import { useBeFigure } from "./BeFigureContextProvider";
import { REMOVE_FIGURE_ITEM } from "./functions/interface";

export interface RemoveFigureItemButtonProps {
  dataPath: string;
  id: string;
}

/**
 * Button component to remove a data row from the figure
 *
 * @param props - Destructured parameter object
 * @param props.dataPath - The RFC 6901 JSON Pointer path to the array containing the item
 * @param props.id - The id of the data row to remove
 */
export const RemoveFigureItemButton = ({
  dataPath,
  id,
}: RemoveFigureItemButtonProps): React.ReactElement => {
  const { dispatch } = useBeFigure();

  return (
    <DashCircle
      id={`remove-${id}`}
      className="text-danger ms-2"
      role="button"
      aria-label="Remove item"
      onClick={() => {
        dispatch({ operation: REMOVE_FIGURE_ITEM, dataPath });
      }}
    />
  );
};

RemoveFigureItemButton.displayName = "RemoveFigureItemButton";
